import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";

@Component({
	selector: "app-pwa-install-prompt",
	templateUrl: "./pwa-install-prompt.component.html",
	styleUrls: ["./pwa-install-prompt.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class PwaInstallPromptComponent {
	data = inject(MAT_BOTTOM_SHEET_DATA);

	private bottomSheetRef: MatBottomSheetRef<PwaInstallPromptComponent> =
		inject(MatBottomSheetRef);

	/** Inserted by Angular inject() migration for backwards compatibility */
	constructor(...args: unknown[]);

	constructor() {}

	public installPwa(): void {
		this.data.promptEvent.prompt();
		this.close();
	}

	public close() {
		this.bottomSheetRef.dismiss();
	}
}
